import type { VideoConfig } from "./types";
import { VideoPlayer } from "./VideoPlayer";
import { useAdaptiveVideoLayout } from "./useAdaptiveVideoLayout";

interface VideoGridProps {
  videos: VideoConfig[];
}

export function VideoGrid({ videos }: VideoGridProps) {
  const visibleVideos = videos.filter((video) => video.visible);
  const { containerRef, dimensions, margin } = useAdaptiveVideoLayout(
    visibleVideos.length,
    {
      margin: 10,
      defaultAspectRatio: "16:9",
    }
  );

  return (
    <div ref={containerRef} id="video-grid" className="adaptive-video-layout">
      {visibleVideos.map((video, index) => (
        <VideoPlayer
          key={video.id}
          video={video}
          dimensions={dimensions[index]}
          margin={margin}
        />
      ))}
    </div>
  );
}

